/* Trigger element */

.Trigger {
  cursor: pointer;
  display: inline-block;
}

/* Content container */

.Content {
  /* Animation for smooth appearance */
  animation: fade-in 0.2s ease-out;
  background: var(--popover, var(--white));
  border: 1px solid var(--border, var(--color-gray-200));
  border-radius: var(--border-radius-lg);
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 10%),
    0 2px 4px -1px rgb(0 0 0 / 6%);
  color: var(--popover-foreground, var(--black));
  font-size: var(--font-size-sm);
  left: var(--hover-left, 0);
  line-height: 1.4;
  max-height: var(--hover-max-height);
  max-width: min(var(--space-6xl), 90vw);
  min-width: fit-content;
  overflow: hidden auto;
  padding: var(--space-lg);
  position: fixed;
  scrollbar-color: var(--muted-foreground, var(--color-gray-500)) transparent;

  /* Custom scrollbar styling */
  scrollbar-width: thin;
  top: var(--hover-top, 0);
  width: max-content;
  z-index: 1000;
}

/* Webkit scrollbar styling */

.Content::-webkit-scrollbar {
  width: var(--space-md);
}

.Content::-webkit-scrollbar-track {
  background: transparent;
}

.Content::-webkit-scrollbar-thumb {
  background-color: var(--muted-foreground, var(--color-gray-500));
  border-radius: var(--border-radius-sm);
  opacity: 50%;
}

.Content::-webkit-scrollbar-thumb:hover {
  background-color: var(--foreground, var(--color-gray-800));
  opacity: 80%;
}

@keyframes fade-in {
  from {
    opacity: 0%;
    transform: scale(0.95);
  }

  to {
    opacity: 100%;
    transform: scale(1);
  }
}

/* Dark mode support */

@media (prefers-color-scheme: dark) {
  .Content {
    background: var(--popover, var(--color-gray-800));
    border-color: var(--border, var(--color-gray-700));
    box-shadow:
      0 4px 6px -1px rgb(0 0 0 / 30%),
      0 2px 4px -1px rgb(0 0 0 / 20%);
    color: var(--popover-foreground, var(--color-gray-100));
  }
}

/* Responsive adjustments */

@media (width <= 768px) {
  .Content {
    font-size: var(--font-size-xs);
    max-width: min(var(--space-5xl), 85vw);
    padding: var(--space-md);
  }
}
